<h2 class="margin-left-md">Shipment Events</h2>
<div class="events-container" *ngIf="shipment; else noEventsDisplayed">
    <fleetoperate-shipment-event *ngFor="let event of shipment.events"
                                  class="quote margin-right-sm margin-bottom-sm margin-left-sm" 
                                  [name]="event.name"
                                  [date]="event.date" [location]="event.location"></fleetoperate-shipment-event>
</div>
<ng-template #noEventsDisplayed>
  No events have occurred yet
</ng-template>